export default __webpack_public_path__ + "static/media/bilgewater.88e01fae.svg";